import React, { useState, useEffect } from "react"
import TemplatePreviewProvider from "lib/units/template/preview/TemplatePreviewProvider"
import TemplatePreview from "lib/designs/defleppard/TemplatePreview"
import GeneratePDF from "lib/pdf/GeneratePDF"



export default function MidmetricsEditor(){

  return (
  // const [ currentStep, setCurrentStep ] = useState<string>("welcome")
    <iframe src="http://localhost:3090/pdf/111?subdomain=woopla&rp=257&mode=render" className="w-6/12 h-full scale-50"></iframe>
  
  )

}